// Each character a custom property name can't hold, `_` included, becomes `_<hex>_`,
// so two different fields can never share a variable.
function encodeField(field: string) {
  return field.replace(
    /[^a-zA-Z0-9-]/g,
    (character) => `_${character.charCodeAt(0).toString(16)}_`,
  );
}

// The width the user dragged the column to.
export function columnWidthVariableName(field: string) {
  return `--data-table-column-width-${encodeField(field)}`;
}

// The widest the column's content has been on any page shown so far.
export function columnFloorVariableName(field: string) {
  return `--data-table-column-floor-${encodeField(field)}`;
}
